// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___AotXu";
var _2 = "styles-module__divider___2y8Ln";
var _3 = "styles-module__header___ezIhH";
var _4 = "styles-module__next___apvOx";
var _5 = "styles-module__previous___D0xL8";
var _6 = "styles-module__riverClass___jZOIL";
var _7 = "styles-module__riverContainer___J0gB6";
var _8 = "styles-module__storeLink___ywXnd";
export { _1 as "container", _2 as "divider", _3 as "header", _4 as "next", _5 as "previous", _6 as "riverClass", _7 as "riverContainer", _8 as "storeLink" }
